import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Sun, Shield, ShoppingBag, Utensils, Mountain, GraduationCap, TreePine, Zap, Car } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
import { ListingsComingSoon } from '../components/ListingsComingSoon';
const placeholderListings = [{
  id: 1,
  price: '$475,000',
  address: '6234 Palmyra Ave',
  area: 'Spring Valley',
  beds: 3,
  baths: 2,
  sqft: '1,850',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 2,
  price: '$625,000',
  address: '8901 W Flamingo Rd',
  area: 'The Lakes',
  beds: 4,
  baths: 3,
  sqft: '2,400',
  image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop'
}, {
  id: 3,
  price: '$550,000',
  address: '3421 Desert Bloom Ct',
  area: 'Spring Valley',
  beds: 4,
  baths: 2.5,
  sqft: '2,200',
  image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2940&auto=format&fit=crop'
}];
export function SpringValleyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white" data-id="element-850">
      <section className="relative h-[70vh] min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-851">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2940&auto=format&fit=crop")'
      }} data-id="element-852">
          <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply" data-id="element-853"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80" data-id="element-854"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-855">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} data-id="element-856">
            <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-6 block" data-id="element-857">
              Community Spotlight
            </span>
            <h1 className="text-5xl md:text-7xl text-white font-serif mb-6 leading-tight" data-id="element-858">
              Spring Valley
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto" data-id="element-859">
              Centrally located with diverse housing options and unbeatable
              access to everything Las Vegas has to offer.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-860">
        <div className="max-w-7xl mx-auto" data-id="element-861">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-862">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-863">
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-864">
                The Heart of <span className="italic text-gold" data-id="element-865">Las Vegas</span>
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-866">
                <p data-id="element-867">
                  Spring Valley is one of the most centrally located communities
                  in the Las Vegas Valley, making it a favorite for
                  professionals, families, and anyone who values convenience.
                  With a population of over 178,000, it's a vibrant and diverse
                  area that puts you minutes from the Strip, Summerlin, and
                  Henderson.
                </p>
                <p data-id="element-868">
                  The community is known for its excellent value — offering
                  spacious homes with large lots at prices well below
                  neighboring Summerlin. You'll find everything from charming
                  single-story ranch homes in the $400K range to stunning custom
                  estates exceeding $1M in gated communities like The Lakes.
                </p>
                <p data-id="element-869">
                  Spring Valley is also home to some of the best Asian cuisine
                  in Las Vegas, centered around the famous Chinatown district
                  along Spring Mountain Road — one of the most acclaimed food
                  corridors in the entire country.
                </p>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-2 gap-6" data-id="element-870">
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-871">
                <Car className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-872" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-873">10m</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-874">
                  To The Strip
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-875">
                <Utensils className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-876" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-877">#1</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-878">
                  Food Scene
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-879">
                <Zap className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-880" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-881">Best</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-882">
                  Value in Vegas
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-883">
                <Sun className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-884" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-885">
                  178K+
                </h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-886">
                  Residents
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Chinatown & Dining */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-887">
        <div className="max-w-7xl mx-auto" data-id="element-888">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-889">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-2 lg:order-1" data-id="element-890">
              <div className="relative h-[500px]" data-id="element-891">
                <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=2874&auto=format&fit=crop" alt="Dining" className="w-full h-full object-cover" data-id="element-892" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-893"></div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-1 lg:order-2" data-id="element-894">
              <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-895">
                Culinary Capital
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-896">
                Chinatown & Dining Scene
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-897">
                <p data-id="element-898">
                  Spring Mountain Road, running through the heart of Spring
                  Valley, is home to Las Vegas's legendary Chinatown — a 3+ mile
                  stretch of incredible Asian restaurants, bakeries, and markets
                  that has been called one of the best food streets in America.
                </p>
                <p data-id="element-899">
                  From authentic ramen and dim sum to Korean BBQ and Vietnamese
                  pho, the dining options are world-class and incredibly
                  affordable. It's a major draw for foodies and a point of pride
                  for Spring Valley residents.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Key Areas */}
      <section className="py-24 px-6 bg-white" data-id="element-900">
        <div className="max-w-7xl mx-auto" data-id="element-901">
          <div className="text-center mb-16" data-id="element-902">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-903">
              Neighborhoods
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-904">Popular Areas</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-905">
            {[{
            name: 'The Lakes',
            price: '$500K - $1.2M',
            desc: 'A prestigious gated community centered around a beautiful man-made lake with waterfront homes and lush landscaping.',
            img: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop'
          }, {
            name: 'Desert Shores',
            price: '$350K - $700K',
            desc: 'A unique lakefront community with four man-made lakes, sandy beaches, and a resort-like atmosphere.',
            img: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2906&auto=format&fit=crop'
          }, {
            name: 'Canyon Gate',
            price: '$400K - $900K',
            desc: 'Guard-gated golf course community with mature trees, a Ted Robinson-designed course, and elegant homes.',
            img: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=2787&auto=format&fit=crop'
          }].map((n, idx) => <motion.div key={n.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-warmGray p-6 border border-warmGray-dark" data-id="element-906">
                <img src={n.img} alt={n.name} className="w-full h-48 object-cover mb-4" data-id="element-907" />
                <div className="flex justify-between items-start mb-3" data-id="element-908">
                  <h3 className="text-xl font-serif text-charcoal" data-id="element-909">{n.name}</h3>
                  <span className="text-xs font-medium text-gold bg-gold/10 px-2 py-1 rounded whitespace-nowrap" data-id="element-910">
                    {n.price}
                  </span>
                </div>
                <p className="text-charcoal-light font-light text-sm leading-relaxed" data-id="element-911">
                  {n.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Convenience */}
      <section className="py-24 bg-warmGray px-6 border-t border-warmGray-dark" data-id="element-912">
        <div className="max-w-7xl mx-auto" data-id="element-913">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-914">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-8" data-id="element-915">
              <div data-id="element-916">
                <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-917">
                  Unbeatable Location
                </span>
                <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-918">
                  Everything Within Reach
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-919">
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-920">
                  <ShoppingBag className="w-6 h-6 text-gold mb-3" data-id="element-921" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-922">
                    Shopping
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-923">
                    Minutes from Fashion Show Mall, Downtown Summerlin, and
                    countless local shops.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-924">
                  <Mountain className="w-6 h-6 text-gold mb-3" data-id="element-925" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-926">
                    Red Rock Canyon
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-927">
                    Just 20 minutes to world-class hiking and the stunning
                    scenic loop drive.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-928">
                  <TreePine className="w-6 h-6 text-gold mb-3" data-id="element-929" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-930">
                    Parks & Recreation
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-931">
                    Desert Breeze Park features a skate park, sports fields, and
                    a popular community center.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-932">
                  <GraduationCap className="w-6 h-6 text-gold mb-3" data-id="element-933" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-934">
                    Great Schools
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-935">
                    Home to Bonanza High School, Spring Valley High School, and
                    several top-rated elementary schools.
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-936">
              <div className="relative h-[600px]" data-id="element-937">
                <img src="https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=2940&auto=format&fit=crop" alt="Spring Valley Living" className="w-full h-full object-cover" data-id="element-938" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-939"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <ListingsComingSoon area="Spring Valley" data-id="element-940" />

      <ContactCTA data-id="element-941" />
    </main>;
}